import {
  fareClassToUrlMap,
  FlightsClassTypes,
} from 'constants/flight'
import { nonNullable } from 'lib/array/arrayUtils'
import { getFareClass } from 'lib/flights/flightUtils'
import type { BookmarkRequest } from 'tripPlanner/api/bookmark/types'
import type {
  TripItemAndOfferAndDatesIdSet,
} from 'tripPlanner/types/common'
import defaultIntl from 'i18n/util/defaultIntl'

type ItemTypes = BookmarkRequest['items'][number]
type TourPayload = Extract<ItemTypes, { type: 'tour_v2' | 'tour' }>

export const getTourKey = ({ code, startDate, endDate }: TourPayload) =>
  nonNullable([code, startDate, endDate]).join('_')

export function getTripItemIdsInCheckout(
  keys: Array<string>,
  idSets: Array<TripItemAndOfferAndDatesIdSet>,
) {
  const itemKeys = new Set(keys)

  const itemIds = idSets
    .filter((s) => itemKeys.has(s.offerIdAndMeta))
    .map((i) => i.itemId)

  return itemIds
}

// External contract FareClass type (excludes 'lux_row')
type ExternalFareClass = 'economy' | 'premium' | 'business' | 'first'

export const mapToFareClass = (fareClass: string): ExternalFareClass => {
  // Map 'lux_row' and 'lux_row_pax_one' to 'economy' as the external contract doesn't support them
  if (fareClass === FlightsClassTypes.LUXROW || fareClass === FlightsClassTypes.LUXROW_PAX_ONE) {
    return 'economy'
  }
  if (fareClass in fareClassToUrlMap) {
    return fareClass as ExternalFareClass
  }

  const normalizedFareClass = getFareClass(fareClass, defaultIntl).toLowerCase()
  if (normalizedFareClass.includes('business')) return 'business'
  if (normalizedFareClass.includes('first')) return 'first'
  if (normalizedFareClass.includes('premium')) return 'premium'
  return 'economy'
}

// Sometimes flight numbers include the carrier code, sometimes they don't... ಥ_ಥ
export function prependCarrierCodeIfNeeded(
  carrierCode: string,
  flightNumber: string,
): string {
  if (flightNumber.match(/^\d+$/)) {
    return carrierCode + flightNumber
  }
  return flightNumber
}
